import React, { useMemo } from "react";
import {
  required,
  number,
  valueGreaterThanZero,
  maxPaymentAmount,
} from "../../../../../utils/formValidators";
import { renderMoneyField, renderOLBStyleMoneyField } from "../../../../../utils/renderField";
import { Field } from "redux-form";
import { removeSpecialCharacters } from "../../../../../utils/utils";
import Show from "../../../../../utils/show.component";
import { usd } from "../../../../../utils/utils";

export const AuthAmountField = (props) => {
  const fieldName = props.isDebit ? "amount" : "Amount";
  const titleBottomPadding = props.isRecurring ? "mb-1" : "mb-4";

  const lessThanAchLimit = useMemo(() => maxPaymentAmount(props.maxAllowedAchAmount), []);

  const valueEqualOrLessThanPayoffLimit = useMemo(
    () => (value) => {
      return value && removeSpecialCharacters(value) <= props.payoffAmount
        ? undefined
        : `The amount cannot exceed ${usd.format(props.payoffAmount)}.`;
    },
    [],
  );

  const valueEqualOrLessThanCurrentBalanceLimit = useMemo(
    () => (value) => {
      return value && removeSpecialCharacters(value) <= props.currentBalance
        ? undefined
        : `The amount cannot exceed ${usd.format(props.currentBalance)}.`;
    },
    [],
  );

  let validators = [number, required, valueGreaterThanZero];

  if (props.isAch) {
    validators.push(lessThanAchLimit);
  }

  if (props.isPrincipalOnly || props.isCreditCard) {
    validators.push(valueEqualOrLessThanCurrentBalanceLimit);
  }

  // Include payoff limiter if this is a non-principal only, standard payment on an open end loan
  if (
    props.isOpenEnd &&
    props.isRecurring === false &&
    !props.isPrincipalOnly &&
    !props.isCreditCard
  ) {
    validators.push(valueEqualOrLessThanPayoffLimit);
  }

  const recurringFrequencyWording = () => {
    if (props.paymentFrequency !== undefined) {
      switch (props.paymentFrequency) {
        case "Monthly":
          return "each month";
        case "Weekly":
          return "each week";
        case "Bi-Weekly":
          return "every other week";
        default:
          return "each period";
      }
    }
  };

  return (
    <div>
      <div className={"bold f18 " + titleBottomPadding}>
        {props.hasSelectedPayoff ? "Payoff Amount" : "Choose Payment Amount"}
      </div>
      <Show condition={props.isRecurring}>
        <div className="mb-4">You will pay this amount {recurringFrequencyWording()}.</div>
      </Show>
      <div className="mb-4">
        <Field
          component={renderOLBStyleMoneyField}
          id="paymentAmount"
          name={fieldName}
          validate={validators}
          type="text"
          inputMode="decimal"
          changeFunction={props.change}
          disabled={props.disabled}
          e2eId="amount"
        />
        <Show condition={props.isDebit}>
          <div className="f14 italic color-grey">
            <span className="bold">$4.95 convenience fee</span> for debit card payments
          </div>
        </Show>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/payment-forms/field-components/general/auth-amount-field.component.js